import(/* webpackMode: "eager" */ "/vercel/path0/apps/scheduler-app/src/app/global-error.tsx");
